// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorBrands = (client) => ({
    /**
     * `POST /vendor/brands`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorBrandsCreate
     * @source packages/modules/b2c-core/src/api/vendor/brands/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/brands", { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/brands`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorBrandsList
     * @source packages/modules/b2c-core/src/api/vendor/brands/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/brands", { method: "GET", query, headers }),
});
//# sourceMappingURL=brands.js.map